let language = {
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_TITLE:"Upload Files",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_TABLE_HEAD_IMAGE:"image",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_TABLE_HEAD_INFO:"info",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_TABLE_HEAD_STATUS:"status",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_FILE_NAME:"Name:",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_FILE_TYPE:"Type:",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_FILE_SIZE:"Size:",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_FILE_MESSAGE:"Message:",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_CANCLE_BTN:"cancel",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_OK_BTN:"ok",

    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_SUCCESS: "success",
    STORE_PRODUCT_SETTING_UPLOAD_FILE_MODAL_FAIL: "fail",
};

export { language }